import { apiFetch } from "./http";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/api";

export async function login(payload) {
  const res = await fetch(`${API_URL}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || "Login failed");
  }

  return data;
}

export async function createUserByAdmin(payload) {
  const res = await apiFetch(`${API_URL}/auth/users`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || "Failed to create user");
  }

  return data;
}
